import {notification} from 'antd';
import {useNavigate} from 'react-router-dom';

import {handleApiError} from 'pm-utils';

import {useCreateRecurringExpenseMutation, useDeleteRecurringExpenseMutation, useUpdateRecurringExpenseMutation} from '../api';
import {RecurringExpense} from '../types';

export function useSaveRecurringExpense(id: string) {
    const navigate = useNavigate()

    const [createRecurringExpense] = useCreateRecurringExpenseMutation();
    const [updateRecurringExpense] = useUpdateRecurringExpenseMutation();

    async function saveRecurringExpense(recurringExpense: Partial<RecurringExpense>) {
        try {
            if (id === 'new') {
                await createRecurringExpense(recurringExpense as RecurringExpense).unwrap()
            } else {
                await updateRecurringExpense({...recurringExpense, id}).unwrap()
            }

            notification.success({message: 'Recurring expense saved'})
            navigate('/auth/recurring-expenses');
        } catch (err) {
            handleApiError(err)
        }
    }

    return saveRecurringExpense;
}

export function useDeleteRecurringExpense(id: string) {
    const navigate = useNavigate()

    const [deleteRecurringExpenseMutation] = useDeleteRecurringExpenseMutation();

    async function deleteRecurringExpense() {
        try {
            await deleteRecurringExpenseMutation(id);

            notification.success({message: 'Recurring expense deleted'})
            navigate('/auth/recurring-expenses')
        } catch (err) {
            handleApiError(err)
        }
    }

    return deleteRecurringExpense;
}
